module.exports = {
	"name": "Belly Deli",
	"foodRecommendations": [
		{
			"text": "Recommend the bulgogi or pork belly buns!",
			"person": "Amelia Cacchione"
		}
	],
	"address": "1317 S University Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.275186,
		"lng": -83.73265
	},
	"catImage": "greenstar.png",
	"totalCats": 1,
	"totalMisc": 0,
	"categories": {
		"location": 1,
		"fooddrink": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/bellydeli.json
// module id = 825
// module chunks = 0